import { addEditableTags } from '..';
import cloneDeep from 'lodash/cloneDeep';

/**
 * @template {import('./types').BaseT} Props The generic type of the model to use.
 * @function
 * @argument {Props} model
 * @argument {string} contentType
 * @argument {boolean} tagsAsObject
 * @argument {string} locale
 * @returns {import('./types').ModelWithLivePreviewAttr<Props>}
 */
export function getModelWithLpTags(model, contentType, tagsAsObject, locale) {
	// Clone object, then add tags.
	const cloned = cloneDeep(model);
	addEditableTags(cloned, contentType, tagsAsObject, locale);

	// @ts-ignore - addEditableTags only supports inline up-typing.
	return cloned;
}
